import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  sendDateInputLabel: 'Send Date',
  sendDateToggleLabel: 'Schedule Send',
  sendDateTooltipText: 'Scheduled Invoices are sent at 09:00am AET',
})
